import axios from 'axios'
const ConfigBaseURL = '/mergePageBack'
const token = localStorage.getItem('token')
const service = axios.create({
    timeout: 100000,
    baseURL: ConfigBaseURL,
    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': token, //请求头
    }
})
export default service;